import { action, computed, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'
import ModalViewModel from 'infra/ModalViewModel'
import JobProgressionViewModel from '../JobProgressionCard/JobProgressionViewModel'
import { OverrideableJobProgressionStepStatus } from 'jobs/progression/JobProgression'
import { AlertFactory } from 'alerts/Alert'

interface StepOption {
  id: OverrideableJobProgressionStepStatus
  display: string
}

export class UpdateProgressionStepDialogVM extends ModalViewModel {
  @observable
  selectedStepOption: StepOption | undefined = undefined

  constructor(
    public jobProgressionVM: JobProgressionViewModel,
    private newAlert: AlertFactory
  ) {
    super()
    makeObservable(this)
  }

  @computed
  get steps(): Array<StepOption> {
    return this.jobProgressionVM.overrideableProgressionSteps.map(
      ([stepId, stepValue]) => ({
        id: stepId,
        display: stepValue.title,
      })
    )
  }

  activate() {
    this.selectProgressionStep(this.steps[0])
  }

  @action.bound
  selectProgressionStep(option?: StepOption) {
    this.selectedStepOption = option
  }

  update = task.resolved(async () => {
    if (!this.selectedStepOption) {
      return
    }

    await this.jobProgressionVM
      .overrideProgressionStep(this.selectedStepOption.id)
      .then(() => this.close())
      .catch((err: any) => {
        console.error(err)

        this.newAlert().show().fromError(err).autoDismiss()
      })
  })
}
